export type RemissionUi = {
  imageUrl: string;
  imageOpenable: boolean;
  cancelDisabled?: boolean;
  saveDisabled?: boolean;
};

export const initialState: RemissionUi = {
  imageUrl: '',
  cancelDisabled: true,
  saveDisabled: true,
  imageOpenable: true,
};
